angular
	.module 'App.Module.Tickets', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY, SEARCH_CONFIGURATION) ->
		$stateProvider
			.state 'tickets',
					url: '/tickets',
					views:
						main:
							templateUrl: '@app/layout/views/app.entity-administration.view.html'
							controller: 'MainCrudController'
							controllerAs: 'mainCrud'

						"entity_search@tickets":
							templateUrl: '@app/layout/views/app.entity-search.view.html'
							controller: 'BaseSearchController'
							controllerAs: 'search'
					data:
						restrict: 'Shared.Setting.Ticket.Enabled'
						searchParams:
							advanced:
								configuration: SEARCH_CONFIGURATION.ticket
							repositoryName: 'TicketRepository'
							title: 'general.tickets'
							createEnabled: false
							attribute: 'id'

			.state 'tickets.edit',
					url: '/:id'
					views:
						entity_view:
							templateUrl: '@app/layout/views/app.entity-container.view.html'
					resolvePolicy: DEFAULT_RESOLVE_POLICY
					resolve:
						ticket: (TicketRepository, $stateParams) ->
							return TicketRepository.getEntity($stateParams.id)
						event: (TicketEventRepository, ticket, $stateParams) ->
							if _.isEmpty($stateParams.id)
								return

							query = TicketEventRepository.createQuery()
							query.withoutAnyRelations()

							return TicketEventRepository.getEntity(ticket.ticket_event_id, query)

			.state 'tickets.edit.details',
					url: '/edit',
					views:
						entity_sub_view:
							controller: 'TicketController'
							controllerAs: 'vm'
							templateUrl: '@app/ticket/ticket.view.html'
